import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer id="contact" className="bg-gray-900 text-white py-12" data-id="element-812" data-mp="3gezcj1s77n03">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-813" data-mp="3ghc3u5juj9pt">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-814" data-mp="32ovuyo49khgz">
          <div className="md:col-span-2" data-id="element-815" data-mp="36p6dt1d5n2d9">
            <div className="flex items-center mb-4" data-id="element-816" data-mp="36q953aee36tp">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8HZiCJw5VjFSfFjXEXdjWt/ChatGPT_Image_Sep_14%2C_2025%2C_09_59_43_PM.png" alt="Ukweli Institute Logo" className="h-10 mr-2 brightness-0 invert" data-id="element-817" data-mp="3ufa4671c15mb" />
            </div>
            <p className="text-gray-400 mb-4 max-w-md" data-id="element-818" data-mp="3qdf3n4r86w9l">
              For Microbiome Research & Therapeutics - Bridging the gap between
              biohacker discovery, consumer wellness, and pharma-level science.
            </p>
            <div className="flex space-x-4" data-id="element-819" data-mp="2eyjoziskwut1">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-820" data-mp="2ew70snw89o7j">
                <span className="sr-only" data-id="element-821" data-mp="3gb8xv7n4lmxp">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-822" data-mp="3gctpaoe58prc">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-823" data-mp="3q7lqs3aujwre" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-824" data-mp="qujlbn5hbf1g">
                <span className="sr-only" data-id="element-825" data-mp="mq3g7o3owbna">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-826" data-mp="tw618ehn64qf">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-827" data-mp="13tao6gjba48a" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-828" data-mp="1mj8qsh4cb54j">
            <h3 className="text-lg font-semibold mb-4" data-id="element-829" data-mp="1mktpmixota87">Quick Links</h3>
            <ul className="space-y-2" data-id="element-830" data-mp="1rilipga2j2dz">
              <li data-id="element-831" data-mp="1rid1jc6wxawz">
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-832" data-mp="1rgsiojtyngey">
                  About
                </Link>
              </li>
              <li data-id="element-833" data-mp="2af3ubumo9blq">
                <Link to="/research" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-834" data-mp="2afdj5evzdcpu">
                  Research
                </Link>
              </li>
              <li data-id="element-835" data-mp="21nbjvjxne2h5">
                <Link to="/certification" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-836" data-mp="21kpftu9yu53o">
                  Certification
                </Link>
              </li>
              <li data-id="element-837" data-mp="2pbuqzw4yo97n">
                <Link to="/product-reviews" className="text-gray-400 hover:text-white transition-colors duration-300" data-id="element-838" data-mp="2pdpg7mn9mnhj">
                  Reviews
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-839" data-mp="18ynubc5v8qxs">
            <h3 className="text-lg font-semibold mb-4" data-id="element-840" data-mp="18yecwcyvzs3p">Contact Us</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-841" data-mp="13zb90vun7rxb">
              <li data-id="element-842" data-mp="13xgohinaa1tr">info@ukweliinstitute.org</li>
              <li data-id="element-843" data-mp="2rvzm7cez23t6">+1 (555) 123-4567</li>
              <li data-id="element-844" data-mp="2ruxz29kolqv3">123 Science Way, Research Park</li>
              <li data-id="element-845" data-mp="2wmg1z369m1ip">Cambridge, MA 02142</li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-800 text-sm text-gray-400 text-center" data-id="element-846" data-mp="2woanailg7vnb">
          <p data-id="element-847" data-mp="2it862zb5ijv7">
            © {new Date().getFullYear()} Ukweli Institute. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};